import React, { useState } from "react";
import {
  Header,
  App,
  Footer,
  MainContent,
  DandeliousText,
  SymbolBehance,
  SymbolLinkedin,
  SymbolGroup,
  FooterText,
  BarraVertical,
  ContactBody,
  ContactHeader,
  ContactBox,
  FooterNav,
  HeaderDivider,
} from "./styles/styles";

import { FaBehance, FaRegStar } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa6";
import { useMediaQuery } from "react-responsive";
import TypeWriter from "typewriter-effect";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

import ProjetoBrand from "./navigation/projetobrand";
import Projeto3d from "./navigation/projeto3d";
import Projetoproduct from "./navigation/projetoproduct";
import ProjetoMarketing from "./navigation/projetoMarketing";

const Inicial = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const [isProjectsOpen, setIsProjectsOpen] = useState(false);
  const [categoriaAtiva, setCategoriaAtiva] = useState(null);

  const toggleProjects = () => {
    setIsProjectsOpen((prev) => !prev);
    if (isProjectsOpen) setCategoriaAtiva(null);
  };

  const categorias = [
    { id: "Event", label: "Event" },
    { id: "3D", label: "3D" },
    { id: "Product", label: "Product" },
    { id: "Web", label: "Web" },
  ];

  const renderProjeto = () => {
    switch (categoriaAtiva) {
      case "Event":
        return <ProjetoBrand />;
      case "3D":
        return <Projeto3d />;
      case "Product":
        return <Projetoproduct />;
      case "Web":
        return <ProjetoMarketing />;
      default:
        return null;
    }
  };

  return (
    <App
      style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
    >
      <Header>
        {!isMobile && (
          <>
            <span
              onClick={toggleProjects}
              viewTransition
              style={{ cursor: "pointer", fontFamily: "Memphis" }}
            >
              Projects
            </span>
            <Link
              to="/home"
              viewTransition
              style={{
                textDecoration: "none",
                color: "black",
                fontFamily: "Memphis",
              }}
            >
              <span>Home</span>
            </Link>
            <Link
              to="/about"
              viewTransition
              style={{
                textDecoration: "none",
                color: "black",
                fontFamily: "Memphis",
              }}
            >
              <span>About</span>
            </Link>
            <Link
              to="/gallery"
              viewTransition
              style={{
                textDecoration: "none",
                color: "black",
                fontFamily: "Memphis",
              }}
            >
              <span>Gallery</span>
            </Link>
          </>
        )}
        <SymbolGroup>
          <a
            href="https://www.linkedin.com/in/mariasouza-dan/"
            target="_blank"
            rel="noreferrer"
          >
            <SymbolLinkedin>
              <FaLinkedinIn />
            </SymbolLinkedin>
          </a>
          <a
            href="https://www.behance.net/Dandelious"
            target="_blank"
            rel="noreferrer"
          >
            <SymbolBehance>
              <FaBehance />
            </SymbolBehance>
          </a>
        </SymbolGroup>
      </Header>

      <HeaderDivider />

      <MainContent
        style={{
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "center",
          padding: isMobile ? "20px" : "40px 5%",
          flex: 1,
          fontFamily: "Memphis",
          textAlign: "left",
          fontWeight: "800",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <DandeliousText
            style={{
              fontSize: isMobile ? "48px" : "120px",
              lineHeight: "0.85",
              margin: 0,
              letterSpacing: "-2px",
            }}
          >
            DANDELIOUS
          </DandeliousText>

          <DandeliousText
            style={{
              fontSize: isMobile ? "48px" : "120px",
              lineHeight: "0.85",
              margin: 0,
              letterSpacing: "-2px",
            }}
          >
            <TypeWriter
              options={{
                strings: [
                  "DESIGNER",
                  "MULTIMEDIA",
                  "VISUAL",
                  "3D ART",
                  "MOTION",
                ],
                autoStart: true,
                loop: true,
              }}
              style={{
                fontFamily: "Memphis",
                fontWeight: "500",
              }}
            />
          </DandeliousText>
        </div>

        <AnimatePresence>
          {isProjectsOpen && (
            <motion.div
              initial={{ opacity: 0, height: 0, marginTop: 0 }}
              animate={{ opacity: 1, height: "auto", marginTop: 20 }}
              exit={{ opacity: 0, height: 0, marginTop: 0 }}
              transition={{ duration: 0.4 }}
              style={{
                display: "flex",
                gap: isMobile ? "20px" : "40px",
                flexWrap: "wrap",
                justifyContent: "flex-start",
                width: "100%",
                overflow: "hidden",
              }}
            >
              {categorias.map((cat) => (
                <motion.span
                  key={cat.id}
                  whileHover={{ scale: 1.1 }}
                  onClick={() => setCategoriaAtiva(cat.id)}
                  style={{
                    fontSize: isMobile ? "18px" : "28px",
                    fontWeight: "bold",
                    cursor: "pointer",
                    textTransform: "uppercase",
                    color: categoriaAtiva === cat.id ? "#D20A2D" : "#000",
                    transition: "color 1s ease",
                    fontFamily: "Memphis",
                    lineHeight: "0.85",
                    margin: 0,
                    letterSpacing: "-2px",
                  }}
                >
                  {cat.label}
                </motion.span>
              ))}
            </motion.div>
          )}
        </AnimatePresence>

        <AnimatePresence mode="wait">
          {categoriaAtiva && (
            <motion.div
              key={categoriaAtiva}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 10 }}
              transition={{ duration: 0.5 }}
              style={{ width: "100%", marginTop: "40px", fontWeight:"300" }}
            >
              {renderProjeto()}
            </motion.div>
          )}
        </AnimatePresence>
      </MainContent>

      <Footer>
        {!isMobile && (
          <FooterText
            style={{
              position: "relative",
              marginTop: "20px",
              fontSize: "40px",
            }}
          >
            Dandelious Designer <FaRegStar />
          </FooterText>
        )}
        <BarraVertical />
        <FooterNav>
          <Link
            to="/about"
            viewTransition
            style={{
              textDecoration: "none",
              color: "black",
              fontFamily: "Memphis",
            }}
          >
            <span>About</span>
          </Link>
          <Link
            to="/home"
            viewTransition
            style={{
              textDecoration: "none",
              color: "black",
              fontFamily: "Memphis",
            }}
          >
            <span>Home</span>
          </Link>
           <span
              onClick={toggleProjects}
              viewTransition
              style={{ cursor: "pointer", fontFamily: "Memphis !Important", textDecoration: "none" }}
            >
              Projects
            </span>
          <Link
            to="/gallery"
            viewTransition
            style={{
              textDecoration: "none",
              color: "black",
              fontFamily: "Memphis",
            }}
          >
            <span>Gallery</span>
          </Link>
        </FooterNav>

        <ContactBox>
          <ContactHeader>Contact</ContactHeader>
          <ContactBody>dandelious.design@gmail.com</ContactBody>
        </ContactBox>
      </Footer>
    </App>
  );
};

export default Inicial;
